import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBlock } from 'components/Shared/InfoBlock';
import { useToggleCart } from 'hooks/cart/useToggleCart';
import * as Styled from './styles';
import * as StyledShared from '../../styles';
import { navigateToExplore } from 'utils';

export const CartCheckoutSuccess = memo(() => {
  const { t } = useTranslation();
  const { handleToggleCart } = useToggleCart();

  const handleButtonClick = useCallback(() => {
    handleToggleCart(false);
    navigateToExplore();
  }, []);

  return (
    <StyledShared.CartContainer>
      <StyledShared.CartHeaderNavigation>
        <Styled.Close />
      </StyledShared.CartHeaderNavigation>
      <InfoBlock
        title={t('cart.checkoutSuccessTitle')}
        type="contrast"
        imageType="payment-success"
        description={t('cart.checkoutSuccessDescription')}
        buttonProps={{
          onClick: handleButtonClick,
          text: t('cart.checkoutSuccessButtonText')
        }}
      />
    </StyledShared.CartContainer>
  );
});
